import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { StageDeleteRequestModel } from '../httpQueue/workflow/stageRequestRunner';

export interface DeleteStageUseCase {
  execute(
    stageId: string,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class StageDeleter implements DeleteStageUseCase {
  constructor(
    private addRequest: (request: StageDeleteRequestModel) => Promise<unknown>
  ) {}

  async execute(
    stageId: string,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('StageDeleter.execute', stageId);
    const request: StageDeleteRequestModel = {
      createdAt: Date.now(),
      method: 'DELETE',
      url: `/project/${projectId}/workflow/${workflowId}/stage/${stageId}`,
      data: {
        stageId,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.workflowStage,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const stageDeleter = new StageDeleter(addRequest);
